import { businessInterface } from "../interfaces/businessInterface";

const getStore = () : businessInterface=>{
    const business : any = window.localStorage.getItem('business'); 
	const storage:businessInterface = JSON.parse(business);
	return storage;
}

const setStore = (data :businessInterface) : void=>{
	window.localStorage.setItem('business', JSON.stringify(data));
}

const deleteStore = () : void=>{
	window.localStorage.clear();
}

export {
	getStore,
	setStore,
	deleteStore
}